import React, { useState } from "react";
import "./Navbar.css";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  // const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* Logo */}
        <NavLink to="/" className="navbar-logo" onClick={closeMenu}>
          <img
            src="/images/mindstreamx-logo-cropped.png"
            alt="MindstreamX Technologies"
            className="navbar-logo-image"
          />
        </NavLink>

        {/* Mobile Menu Button */}
        <button
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
          type="button"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${menuOpen ? "menu-open" : ""}`}>
          <li>
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              Home
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/about-us"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              About Us
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/services"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              Services
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/portfolio"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              Portfolio
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/contactus"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={closeMenu}
            >
              Contact Us
            </NavLink>
          </li>

          {/* Mobile Let's Talk 
          <li className="mobile-talk-item">
            <button
              className="mobile-talk-btn"
              onClick={() => {
                navigate("/contactus");
                closeMenu();
              }}
              type="button"
            >
              Let's Talk <span>→</span>
            </button>
          </li>*/}
        </ul>

        {/* Desktop Let's Talk 
        <button
          className="talk-btn"
          onClick={() => navigate("/contactus")}
          type="button"
        >
          Let's Talk <span>→</span>
        </button>*/}
      </div>
    </nav>
  );
};

export default Navbar;
